import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: '30px 0',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 20px'
    }
  },
  title: {
    margin: '0 0 12px',
  },
  inputIndent: {
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 20px 0px 20px',
      alignItems: 'flex-center',
    }
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-center',
    },
  },
  column: {
    width: '286px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      alignItems: 'flex-center',
    },
  },
  dropDown: {
    width: '285px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }
}));